import pubsub from 'pubsub-js';
import gaTracker from './ga-tracker';

var $modal,
	$modalTitle,
	$modalBody,
	$modalButtons;

function init() {
	
	$modal = $('#js-video-modal');
	$modalTitle = $('.js-modal-title');
	$modalBody = $('.js-modal-body');
	$modalButtons = $('.js-trigger-video-modal');
		
	$modalButtons.on('click', showModal);
	$modal.on('hide.bs.modal', clearVideo);
	
	pubsub.subscribe('modal.video.show', showModal);
	pubsub.subscribe('modal.video.hide', showModal);
}

function showModal(event, data) {
	
	try {
		event.preventDefault();
	} catch(e) {}
	
	var $this = $(this),
		video = (data && data.id) ? data.id : $this.data('video-id'),
		title = (data && data.title) ? data.title : $this.data('video-title');
		
	if (title) {
		$modalTitle.html(title);
	}
	
	if (!$this.data('ga')) {
		gaTracker.track('video|Video Interaction|Selection|Open Video|' + title);
	}
	
	// Template literal with interpolated "video" variable.
	$modalBody.html(`<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${video}?rel=0&showinfo=0" frameborder="0" allowfullscreen></iframe>`);
	
	if (video) {
		$modal.modal('show');
	} else {
		window.location.href = $this.attr('href');
	}
	
}

function closeModal(event, data) {
	$modal.modal('hide');
}

function clearVideo() {
	$modalTitle.html('');
	$modalBody.html('');
}

export default init;